import {Injectable} from "@angular/core";
import {
  CreateDocumentTemplateInput,
  CreateDocumentTemplateMutation,
  DeleteDocumentTemplateMutation, DocumentTemplatesQuery, DocumentTemplatesVariables,
  DocumentTemplateType, UpdateDocumentTemplateInput, UpdateDocumentTemplateMutation
} from "@generated/graphql";
import {map} from "rxjs";
import {documentTemplateFactory} from "@modules/document-template/factories/document-template.factory";
import {paginationDataFactory} from "@shared/factories/pagination.factory";

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateApi {
  constructor(
    private readonly createDocumentTemplateMutation: CreateDocumentTemplateMutation,
    private readonly deleteDocumentTemplateMutation: DeleteDocumentTemplateMutation,
    private readonly updateDocumentTemplateMutation: UpdateDocumentTemplateMutation,
    private readonly documentTemplatesQuery: DocumentTemplatesQuery,
  ) {
  }

  get$(input: DocumentTemplatesVariables) {
    return this.documentTemplatesQuery.fetch(input, {fetchPolicy: 'no-cache'}).pipe(
      map((res) => paginationDataFactory.create(res.data.documentTemplates, documentTemplateFactory)),
    )
  }

  create$(input: CreateDocumentTemplateInput) {
    return this.createDocumentTemplateMutation.mutate({input}, {
      context: {
        useMultipart: true,
      },
    }).pipe(
      map(res => res.data.createDocumentTemplate
        ? documentTemplateFactory.create(res.data.createDocumentTemplate as DocumentTemplateType)
        : null
      )
    )
  }

  update$(input: UpdateDocumentTemplateInput) {
    return this.updateDocumentTemplateMutation.mutate({input}, {
      context: {
        useMultipart: true,
      },
    }).pipe(
      map(res => res.data.updateDocumentTemplate
        ? documentTemplateFactory.create(res.data.updateDocumentTemplate as DocumentTemplateType)
        : null
      )
    )
  }

  delete$(id: string) {
    return this.deleteDocumentTemplateMutation.mutate({id}).pipe(
      map(res => res.data.deleteDocumentTemplate)
    )
  }
}
